import { isValidElement } from 'react';
import VisuallyHidden from '@atlaskit/visually-hidden';
export const getIfVisuallyHiddenChildren = children => {
  return children && /*#__PURE__*/isValidElement(children) && children.type === VisuallyHidden;
};